import {Component, OnInit, TemplateRef} from '@angular/core';
import {ToastService} from '../services/toast.service';
import {NgbToastModule} from '@ng-bootstrap/ng-bootstrap';
import {NgForOf, NgIf, NgTemplateOutlet} from '@angular/common';

@Component({
    selector: 'app-toast',
    templateUrl: './toast.component.html',
    imports: [
        NgbToastModule,
        NgForOf,
        NgIf,
        NgTemplateOutlet
    ],
    styleUrls: ['./toast.component.css']
})
export class ToastComponent {

  constructor(public toastService: ToastService) {}


  isTemplate(toast) {
    return toast.textOrTpl instanceof TemplateRef;
  }

}
